import axios from 'axios';
import { app_version } from './Utils';

export const serverUrl = `${process.env.REACT_APP_SERVER_URL || ''}`;

axios.defaults.headers.post['Content-Type'] ='application/json';

const ArthaGateway = {
    validateLogin: async function(username, password) {
        try {
            const payload = { username: username, password: password };
            let response = await axios.post(serverUrl + '/user/validate', payload);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::validateLogin ->"+ error);
            throw error;
        }
        return false;
    },
    getBankAccounts: async function() {
        try {
            const params = { groupId: 2, subGroupId: 0, pageNumber: 1, pageSize: 1000  };
            let response = await axios.get(serverUrl + '/accounting/bankAccount', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getDealers ->"+ error);
            throw error;
        }
        return undefined;
    },
    getPaymentRequests: async function(date, status: Number = 0) {
        try {
            const params = { durationId: "-1", from: date, to: date, status  };
            let response = await axios.get(serverUrl + '/accounting/paymentRequest', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getDealers ->"+ error);
            throw error;
        }
        return undefined;
    },
    updatePaymentRequest: async function(paymentRequest) {
        try {
            let response = await axios.post(serverUrl + '/accounting/paymentRequest', paymentRequest);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getDealers ->"+ error);
            throw error;
        }
        return undefined;
    },
    postponePaymentRequest: async function(paymentRequest) {
        try {
            let response = await axios.post(serverUrl + '/accounting/paymentRequest/postpone', paymentRequest);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getDealers ->"+ error);
            throw error;
        }
        return undefined;
    },
    getDealers: async function(salesPersonId, reportsToId, name = "", districtId = 0, talukId = 0, pageNumber = 1, pageSize = 10, dealerType = 0, activeOnly = true) {
        try {
            const params = { salesPersonId, reportsToId, name, talukId, districtId, pageNumber, pageSize, dealerType, activeOnly, fields: "Id,Name,GSTIN"  };
            let response = await axios.get(serverUrl + '/master/dealer', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getDealers ->"+ error);
            throw error;
        }
        return undefined;
    },
    getDealerDetails: async function(id) {
        try {
            let response = await axios.get(serverUrl + '/master/dealer/' + id);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getDealers ->"+ error);
            throw error;
        }
        return undefined;
    },
    getBalance: async function(accountId) {
        try {
            let response = await axios.get(serverUrl + '/accounting/account/'+ accountId.toString() + '/balance');
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getDealer ->"+ error);
            throw error;
        }
        return undefined;
    },
    getTransactions: async function(accountId, durationId, pageNumber = 1, pageSize = 10) {
        try {
            if(pageNumber <= 0) { 
                pageNumber = 1; 
            }
            const params = { durationId, accountId, pageNumber, pageSize  };
            let response = await axios.get(serverUrl + '/accounting/account/'+ accountId + "/transaction", { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getBusinessSummary: async function(partId, durationId) {
        try {
            const params = { durationId  };
            let response = await axios.get(serverUrl + '/master/party/businessSummary/'+ partId, { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesPersonBusinessSummary: async function(salesPersonId, durationId) {
        try {
            const params = { salesPersonId, durationId  };
            let response = await axios.get(serverUrl + '/master/salesPerson/businessSummary/', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getSalesPersonBusinessSummary ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesPersonOutstandingSummary: async function(salesPersonId, asOn) {
        try {
            const params = { salesPersonId, asOn  };
            let response = await axios.get(serverUrl + '/master/salesPerson/outstandingSummary/', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getSalesPersonOutstandingSummary ->"+ error);
            throw error;
        }
        return undefined;
    },
    getPendingInvoices: async function(partyId) {
        try {
            const params = { partyId  };
            let response = await axios.get(serverUrl + '/voucher/sale/pending', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getPendingInvoices ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesperson: async function() {
        try {
            const params = { activeOnly: true, reportsTo: -1  };
            let response = await axios.get(serverUrl + '/master/salesPerson', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSales: async function(partyId: number, durationId: string, salesPersonId: number, pageNumber: number = 1, pageSize: number = 10) {
        try {
            const params = { partyId, durationId, salesPersonId, aymentType: 0, departmentId: 0, companyId: 0, pageNumber, pageSize  };
            let response = await axios.get(serverUrl + '/voucher/sale', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesSummary: async function(partyId: number, durationId: string, salesPersonId: number) {
        try {
            const params = { partyId, durationId, salesPersonId, aymentType: 0, departmentId: 0, companyId: 0  };
            let response = await axios.get(serverUrl + '/voucher/sale/summary', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getReceipts: async function(partyId: number, durationId: string, salesPersonId: number, pageNumber: number = 1, pageSize: number = 10) {
        try {
            const params = { partyId, durationId, salesPersonId, aymentType: 0, departmentId: 0, companyId: 0, pageNumber, pageSize  };
            let response = await axios.get(serverUrl + '/voucher/receipt', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getReceiptsSummary: async function(partyId: number, durationId: string, salesPersonId: number) {
        try {
            const params = { partyId, durationId, salesPersonId, aymentType: 0, departmentId: 0, companyId: 0  };
            let response = await axios.get(serverUrl + '/voucher/receipt/summary', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getCreditNotes: async function(partyId: number, durationId: string, salesPersonId: number, pageNumber: number = 1, pageSize: number = 10) {
        try {
            const params = { partyId, durationId, salesPersonId, pageNumber, pageSize  };
            let response = await axios.get(serverUrl + '/voucher/creditNote', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getCreditNote ->"+ error);
            throw error;
        }
        return undefined;
    },
    getCreditNotesSummary: async function(partyId: number, durationId: string, salesPersonId: number) {
        try {
            const params = { partyId, durationId, salesPersonId, aymentType: 0, departmentId: 0, companyId: 0  };
            let response = await axios.get(serverUrl + '/voucher/creditNote/summary', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getCreditNoteSummary ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesFileLink: async function(saleId) {
        try {
            let response = await axios.get(serverUrl + '/voucher/sale/pdf/'+ saleId);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesOrderFileLink: async function(salesOrderId) {
        try {
            let response = await axios.get(serverUrl + '/voucher/order/pdf/'+ salesOrderId);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getReceiptFileLink: async function(receiptId) {
        try {
            let response = await axios.get(serverUrl + '/voucher/receipt/pdf/'+ receiptId);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getReceiptFileLink ->"+ error);
            throw error;
        }
        return undefined;
    },
    getCreditNoteFileLink: async function(creditNoteId) {
        try {
            let response = await axios.get(serverUrl + '/voucher/creditNote/pdf/'+ creditNoteId);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getCreditNoteFileLink ->"+ error);
            throw error;
        }
        return undefined;
    },
    getDealerStatementFileLink: async function(accountId, durationId) {
        try {
            const params = { durationId  };
            let response = await axios.get(serverUrl + '/master/dealer/statement/pdf/'+ accountId, { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getOutstandingReportFileLink: async function(dealerId) {
        try {
            let response = await axios.get(serverUrl + '/master/dealer/outstanding/pdf/'+ dealerId);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getOrders: async function(partyId: number, durationId: string, salesPersonId: number, deliveryStatus: number, pageNumber: number = 1, pageSize: number = 10) {
        try {
            const params = { partyId, durationId, salesPersonId, deliveryStatus, departmentId: 0, companyId: 0, pageNumber, pageSize  };
            let response = await axios.get(serverUrl + '/voucher/order', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getOrdersSummary: async function(partyId: number, durationId: string, salesPersonId: number, deliveryStatus: number) {
        try {
            const params = { partyId, durationId, salesPersonId, deliveryStatus, departmentId: 0, companyId: 0  };
            let response = await axios.get(serverUrl + '/voucher/order/summary', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getCreditNoteSummary ->"+ error);
            throw error;
        }
        return undefined;
    },
    getCreditNoteEligibality: async function(partyId: number) {
        try {
            const params = { partyId };
            let response = await axios.get(serverUrl + '/reports/party/creditNoteEligibality', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },    
    initiatePayment: async function(partyId, amount) {
        try {
            let redirectionUrl = window.location.origin + "/payment/result";
            const params = { partyId, amount, redirectionUrl  };
            let response = await axios.get(serverUrl + '/phonepe/initiate', { params });
            if (response) {  
                console.log(response);
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },    
    processPayment: async function(tid, churn) {
        try {
            const params = { tid, churn  };
            let response = await axios.get(serverUrl + '/phonepe/process', { params });
            if (response) {  
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    logActivity: async function(activity) {
        try {
            let logActivity = { ...activity, appVersion: app_version }
            let response = await axios.post(serverUrl + '/master/dealer/app/activity', logActivity);
            if (response) {  
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::logActivity ->"+ error);
            throw error;
        }
        return undefined;
    },
    unblockParty: async function(partyId) {
        try {
            let response = await axios.get(serverUrl + '/master/party/unblock/'+ partyId);
            if (response) {  
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::unblockParty ->"+ error);
            throw error;
        }
        return undefined;
    },
    approveParty: async function(partyId) {
        try {
            let response = await axios.get(serverUrl + '/master/party/approve/'+ partyId);
            if (response) {  
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::approveParty ->"+ error);
            throw error;
        }
        return undefined;
    },
    getVehicles: async function() {
        try {
            const params = { activeOnly: true };
            let response = await axios.get(serverUrl + '/master/vehicle', { params });
            if (response) {  
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getVehicles ->"+ error);
            throw error;
        }
        return undefined;
    },
    getEmployes: async function(nameHint = "", groupId= 0) {
        try {
            const params = { activeOnly: true, name: nameHint, pageNumber: 1, pageSize: 25, fields: "Id,Name,GroupName,MobileNumber", groupId };
            let response = await axios.get(serverUrl + '/master/employee', { params });
            if (response) {  
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getEmployes ->"+ error);
            throw error;
        }
    },
     getParty: async function(name = "", type = '', pageNumber = 1, pageSize = 10, dealerType = 0, activeOnly = true) {
        try {
            const params = { name, type, pageNumber, pageSize, dealerType, activeOnly, fields: "Id,Name,GSTIN"  };
            let response = await axios.get(serverUrl + '/master/party', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getParty ->"+ error);
            throw error;
        }
        return undefined;
    },
    getProductionPlants: async function() {
        try {
            let response = await axios.get(serverUrl + '/master/productionPlant');
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getProductionPlants ->"+ error);
            throw error;
        }
        return undefined;
    },
    getLoadingIndents: async function(durationId: string, fromDate: string, toDate: string, partyId: number = 0, plantId: number = 0, status: number = 0, voucherNumber: string = "", pageNumber: number = 1, pageSize: number = 10) {
        try {
            const params = { partyId, durationId, plantId, status, voucherNumber, pageNumber, pageSize, fromDate, toDate };
            let response = await axios.get(serverUrl + '/voucher/indent', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getLoadingIndents ->"+ error);
            throw error;
        }
        return undefined;
    },
    getLoadingIndent: async function(indentId: number) {
        try {
            let response = await axios.get(serverUrl + '/voucher/indent/' + indentId);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getLoadingIndent ->"+ error);
            throw error;
        }
        return undefined;
    },
    saveLoadingIndent: async function(indent, userId: number) {
        try {
            let response = await axios.post(serverUrl + '/voucher/indent?userId=' + userId, indent);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::saveLoadingIndent ->"+ error);
            throw error;
        }
        return undefined;
    },
    saveGatepass: async function(gatepass, files, userId: number) {
        try {
            let formData = new FormData();
            formData.append("gatepass", JSON.stringify(gatepass));
            files.forEach(file => {
                formData.append("files", file);
            });
            let response = await axios.post(serverUrl + '/voucher/gatepass?userId=' + userId, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::saveGatepass ->"+ error);
            throw error;
        }
        return undefined;
    }
};

export default ArthaGateway;